import { ActionReducerMap } from '@ngrx/store';

import { menuItemsReducer } from './reducers/menu-items.reducer';
import { userReducer } from './reducers/user.reducer';
import { MenuItem, User } from '@domain/types';

export type IAppState = {
    menuItemsState: MenuItem[];
    userState: User;
};

export const APP_REDUCERS: ActionReducerMap<IAppState> = {
    menuItemsState: menuItemsReducer,
    userState: userReducer,
};
